if (!customElements.get('featured-icon-carousel')) {
  class FeaturedIconCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-fic-track]');
      if (!this.track) return;
      this.prev = this.querySelector('[data-fic-prev]');
      this.next = this.querySelector('[data-fic-next]');

      this.onScroll = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
      if (this.next) this.next.addEventListener('click', () => this.step(1));
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(this.onScroll);
      this.resizeObserver.observe(this.track);

      this.track.addEventListener('pointerdown', (event) => this.dragStart(event));
      this.track.addEventListener('click', (event) => {
        if (this.dragged) {
          event.preventDefault();
          event.stopPropagation();
          this.dragged = false;
        }
      }, true);

      this.update();
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    dragStart(event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (this.track.scrollWidth <= this.track.clientWidth) return;

      const startX = event.clientX;
      const startScroll = this.track.scrollLeft;
      this.dragged = false;

      const move = (moveEvent) => {
        const delta = moveEvent.clientX - startX;
        if (!this.dragged && Math.abs(delta) > 5) {
          this.dragged = true;
          this.track.classList.add('is-dragging');
        }
        if (this.dragged) this.track.scrollLeft = startScroll - delta;
      };

      const end = () => {
        window.removeEventListener('pointermove', move);
        window.removeEventListener('pointerup', end);
        window.removeEventListener('pointercancel', end);
        if (!this.dragged) return;
        const left = this.track.scrollLeft;
        this.track.classList.remove('is-dragging');
        this.track.scrollLeft = left;
        this.snapToNearest();
      };

      window.addEventListener('pointermove', move);
      window.addEventListener('pointerup', end);
      window.addEventListener('pointercancel', end);
    }

    snapToNearest() {
      const items = this.track.querySelectorAll('.fic__item');
      const padding = parseFloat(getComputedStyle(this.track).scrollPaddingLeft) || 0;
      const origin = this.track.getBoundingClientRect().left + padding;
      let closest = Infinity;
      items.forEach((item) => {
        const offset = item.getBoundingClientRect().left - origin;
        if (Math.abs(offset) < Math.abs(closest)) closest = offset;
      });
      if (!Number.isFinite(closest)) return;
      this.track.scrollBy({ left: closest, behavior: 'smooth' });
    }

    step(direction) {
      const item = this.track.querySelector('.fic__item');
      if (!item) return;
      const style = getComputedStyle(this.track);
      const gap = parseFloat(style.columnGap) || 0;
      const inner = this.track.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
      const itemWidth = item.getBoundingClientRect().width + gap;
      const perPage = Math.max(1, Math.floor((inner + gap) / itemWidth));
      this.track.scrollBy({ left: direction * perPage * itemWidth });
    }

    update() {
      if (!this.prev || !this.next) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.prev.disabled = this.track.scrollLeft <= 1;
      this.next.disabled = this.track.scrollLeft >= max - 1;
    }
  }

  customElements.define('featured-icon-carousel', FeaturedIconCarousel);
}
